import { IMarketer } from '@/shared/model/marketer.model';
import { ICustomer } from '@/shared/model/customer.model';
import { IRestaurantCategory } from '@/shared/model/restaurant-category.model';
import { IRating } from '@/shared/model/rating.model';
import { IDeliverySpec } from '@/shared/model/delivery-spec.model';
import { IRestaurant } from '@/shared/model/restaurant.model';
import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { IRestaurantWorkingTimes } from '@/shared/model/restaurant-working-times.model';
import { IUser } from '@/shared/model/user.model';
import { IDiscount } from '@/shared/model/discount.model';
import { IAddress } from '@/shared/model/address.model';
import { IRestaurantStore } from './types';
import { IOrderDetail } from '@/shared/model/order/order-detail.model';

export const getters: GetterTree<IRestaurantStore, RootState> = {
  getRestaurant(state): IRestaurant {
    return state.restaurant;
  },
  getId(state): number {
    return state.restaurant.id;
  },
  getName(state): string {
    return state.restaurant.name;
  },
  getLogoContentType(state): string {
    return state.restaurant.logoContentType;
  },
  getLogoPath(state): string {
    return state.restaurant.logoPath;
  },
  getLogo(state): string {
    return state.restaurant.logo;
  },
  getImageContentType(state): string {
    return state.restaurant.imageContentType;
  },
  getImage(state): string {
    return state.restaurant.image;
  },
  getImagePath(state): string {
    return state.restaurant.imagePath;
  },
  getRegisterNumber(state): string {
    return state.restaurant.registerNumber;
  },
  getTaxIdentificationNumber(state): string {
    return state.restaurant.taxIdentificationNumber;
  },
  getDeliver(state): boolean {
    return state.restaurant.deliver;
  },
  getPickup(state): boolean {
    return state.restaurant.pickup;
  },
  getAddress(state): IAddress {
    return state.restaurant.address;
  },
  getStreet(state): string {
    return state.restaurant.address.street;
  },
  getNumber(state): string {
    return state.restaurant.address.number;
  },
  getAddressAddition(state): string {
    return state.restaurant.address.addressAddition;
  },
  getZipcode(state): string {
    return state.restaurant.address.zipcode;
  },
  getCity(state): string {
    return state.restaurant.address.city;
  },
  getPhone(state): string {
    return state.restaurant.address.phone;
  },
  getBankAccountName(state): string {
    return state.restaurant.bankAccountName;
  },
  getIbanNumber(state): string {
    return state.restaurant.ibanNumber;
  },
  getEnabled(state): boolean {
    return state.restaurant.enabled;
  },
  getStartingDate(state): Date {
    return state.restaurant.startingDate;
  },
  getStartingDateString(state): string {
    return state.restaurant.startingDateString;
  },
  getDomain(state): boolean {
    return state.restaurant.domain;
  },
  getMenuCard(state): string[] {
    return state.restaurant.menuCard;
  },
  getMenuCardPath(state): string {
    return state.restaurant.menuCardPath;
  },
  getMenuCardContentType(state): string {
    return state.restaurant.menuCardContentType;
  },
  getIdCard(state): string[] {
    return state.restaurant.idCard;
  },
  getIdCardPath(state): string {
    return state.restaurant.idCardPath;
  },
  getIdCardContentType(state): string {
    return state.restaurant.idCardContentType;
  },
  getCocRegistration(state): string[] {
    return state.restaurant.cocRegistration;
  },
  getCocRegistrationPath(state): string {
    return state.restaurant.cocRegistrationPath;
  },
  getCocRegistrationContentType(state): string {
    return state.restaurant.cocRegistrationContentType;
  },
  getBankCard(state): string[] {
    return state.restaurant.bankCard;
  },
  getBankCardPath(state): string {
    return state.restaurant.bankCardPath;
  },
  getBankCardContentType(state): string {
    return state.restaurant.bankCardContentType;
  },
  getUser(state): IUser {
    return state.restaurant.user;
  },
  getFoodDiscount(state): IDiscount {
    return state.restaurant.foodDiscount;
  },
  getNonfoodDiscount(state): IDiscount {
    return state.restaurant.nonfoodDiscount;
  },
  getRatings(state): IRating[] {
    return state.restaurant.ratings;
  },
  getDeliverySpecs(state): IDeliverySpec[] {
    return state.restaurant.deliverySpecs;
  },
  getRestaurantWorkingTimes(state): IRestaurantWorkingTimes[] {
    return state.restaurant.restaurantWorkingTimes;
  },
  getMenuCategories(state): IRestaurantCategory[] {
    return state.restaurant.menuCategories;
  },
  getRestaurantCategories(state): IRestaurantCategory[] {
    return state.restaurant.restaurantCategories;
  },
  getCustomer(state): ICustomer {
    return state.restaurant.customer;
  },
  getMarketer(state): IMarketer {
    return state.restaurant.marketer;
  },
  getDateOfBirth(state): Date {
    return state.restaurant.dateOfBirth;
  },
  getTab(state): string {
    return state.tab;
  },
  getDrawer(state): boolean {
    return state.drawer;
  },
  getProvideNow(state): boolean {
    return state.provideNow;
  },
  getNotFound(state): string {
    return state.notFound;
  },
  getPause(state): boolean {
    return state.pause;
  },
  getReadyOrders(state): IOrderDetail[] {
    return state.orders;
  },
  getWorkingTimes(state): IRestaurantWorkingTimes[][] {
    return state.workingTimes;
  },
  getPreparingOrdersNumber(state): number {
    return state.preparingOrdersNumber;
  },
};
